import {secondaryGetFormData} from '../../../utilities/helper/formDataConvertor';
import request from '../../axios';

const PostStoreRedesignView = async (payload: IStoreLabRedesignView) => {
  await request.post(
    'api/v2/store/store-redesign-view',
    secondaryGetFormData(payload as unknown as {[name: string]: string | Blob}),
  );
};

export default PostStoreRedesignView;
